import { FlipCard, FlipCardBadge, FlipCardContent } from "../FlipCard";

export default function SectionTwo() {
  return (
    <div className="w-full space-y-16">
      <div className="space-y-1 text-center">
        <h1 className="font-newsreader text-5xl leading-12 font-bold -tracking-wide text-neutral-950">
          Every problem has a solution
        </h1>
        <p className="text-2xl leading-normal font-medium tracking-normal text-neutral-800">
          Hover over each challenge to see how Metawhale solves it
        </p>
      </div>
      <div className="relative grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div
            className="h-[400px] w-[1000px] rounded-full"
            style={{
              background:
                "radial-gradient(circle, #EA580CBF 0%, transparent 100%)",
              filter: "blur(120px)",
              opacity: "25%",
            }}
          />
        </div>
        <div>
          <FlipCard
            frontContent={
              <FlipCardContent
                variant="front"
                badge={<FlipCardBadge variant="problem">Problem</FlipCardBadge>}
                title="Broadcast mentions vanish"
                description="A well-known celebrity mentioned your brand on primetime TV. A radio host discussed your competitor. You had no idea until someone told you days later."
                footer={
                  <div className="flex items-center gap-2 font-semibold text-neutral-400">
                    <i className="ri-loop-right-line text-md" />
                    <span>See how Metawhale solves this</span>
                  </div>
                }
              />
            }
            backContent={
              <FlipCardContent
                variant="back"
                badge={
                  <FlipCardBadge variant="solution">Solution</FlipCardBadge>
                }
                title="TV & Radio Coverage"
                description="Monitor GMA, ABS-CBN, TV5, CNN Philippines, DZBB, DZMM, and more. Capture broadcast mentions as they air."
                footer={
                  <div className="flex items-center gap-2">
                    <i className="ri-tv-line text-md" />
                    <span>Broadcast monitoring</span>
                  </div>
                }
              />
            }
          />
        </div>
        <div className="h-[268px]">
          <FlipCard
            frontContent={
              <FlipCardContent
                variant="front"
                badge={<FlipCardBadge variant="problem">Problem</FlipCardBadge>}
                title="Global tools, local blindspots"
                description="International platforms miss Philippine provincial papers, local radio, and regional news sources."
                footer={
                  <div className="flex items-center gap-2 font-semibold text-neutral-400">
                    <i className="ri-loop-right-line text-md" />
                    <span>See how Metawhale solves this</span>
                  </div>
                }
              />
            }
            backContent={
              <FlipCardContent
                variant="back"
                badge={
                  <FlipCardBadge variant="solution">Solution</FlipCardBadge>
                }
                title="Built for the Philippines"
                description="100+ local sources including Inquirer, ABS-CBN, GMA, provincial papers, AM/FM radio, and regional outlets."
                footer={
                  <div className="flex items-center gap-2">
                    <i className="ri-tv-line text-md" />
                    <span>Local coverage</span>
                  </div>
                }
              />
            }
          />
        </div>
        <div className="h-[268px]">
          <FlipCard
            frontContent={
              <FlipCardContent
                variant="front"
                badge={<FlipCardBadge variant="problem">Problem</FlipCardBadge>}
                title="Social OR traditional--pick one"
                description="Most monitoring tools force you to choose between social media coverage or traditional media. Never both."
                footer={
                  <div className="flex items-center gap-2 font-semibold text-neutral-400">
                    <i className="ri-loop-right-line text-md" />
                    <span>See how Metawhale solves this</span>
                  </div>
                }
              />
            }
            backContent={
              <FlipCardContent
                variant="back"
                badge={
                  <FlipCardBadge variant="solution">Solution</FlipCardBadge>
                }
                title="Quad Media + Social"
                description="Track influencers on FB, IG, X, TikTok, YouTube AND monitor print, TV, radio broadcasts. No compromises."
                footer={
                  <div className="flex items-center gap-2">
                    <i className="ri-tv-line text-md" />
                    <span>Complete coverage</span>
                  </div>
                }
              />
            }
          />
        </div>
        <div className="h-[268px]">
          <FlipCard
            frontContent={
              <FlipCardContent
                variant="front"
                badge={<FlipCardBadge variant="problem">Problem</FlipCardBadge>}
                title="Faking real time"
                description="Your current tool says “real-time”, but you’re still waiting hours for updates. Crises don’t wait."
                footer={
                  <div className="flex items-center gap-2 font-semibold text-neutral-400">
                    <i className="ri-loop-right-line text-md" />
                    <span>See how Metawhale solves this</span>
                  </div>
                }
              />
            }
            backContent={
              <FlipCardContent
                variant="back"
                badge={
                  <FlipCardBadge variant="solution">Solution</FlipCardBadge>
                }
                title="Actually Real-Time"
                description="Mentions captured as they happen. Pulse monitoring keeps engagement metrics fresh. Stay ahead, not behind."
                footer={
                  <div className="flex items-center gap-2">
                    <i className="ri-tv-line text-md" />
                    <span>Pulse monitoring</span>
                  </div>
                }
              />
            }
          />
        </div>
        <div className="h-[400px]">
          <FlipCard
            frontContent={
              <FlipCardContent
                variant="front"
                badge={<FlipCardBadge variant="problem">Problem</FlipCardBadge>}
                title="Competitor blind spots"
                description="Your brand, products, executives, or industry topic gets mentioned--but without the right keywords tracked, you miss conversations that matter."
                footer={
                  <div className="flex items-center gap-2 font-semibold text-neutral-400">
                    <i className="ri-loop-right-line text-md" />
                    <span>See how Metawhale solves this</span>
                  </div>
                }
              />
            }
            backContent={
              <FlipCardContent
                variant="back"
                badge={
                  <FlipCardBadge variant="solution">Solution</FlipCardBadge>
                }
                title="Powerful Keyword Monitoring"
                description="Track any keyword, phrase, or topic across all media types. From brand mentions to industry trends—capture every conversation in real time."
                footer={
                  <div className="flex items-center gap-2">
                    <i className="ri-tv-line text-md" />
                    <span>Keyword monitoring</span>
                  </div>
                }
              />
            }
          />
        </div>
        <div className="h-[400px]">
          <FlipCard
            frontContent={
              <FlipCardContent
                variant="front"
                badge={<FlipCardBadge variant="problem">Problem</FlipCardBadge>}
                title="Influencers fly under the radar"
                description="An influencer with 500k followers just posted about your industry. By the time you find out, the conversation has moved on."
                footer={
                  <div className="flex items-center gap-2 font-semibold text-neutral-400">
                    <i className="ri-loop-right-line text-md" />
                    <span>See how Metawhale solves this</span>
                  </div>
                }
              />
            }
            backContent={
              <FlipCardContent
                variant="back"
                badge={
                  <FlipCardBadge variant="solution">Solution</FlipCardBadge>
                }
                title="Influencer Tracking Built-In"
                description="Add any influencer to your watchlist. Track their posts, engagement, and reach across Facebook, Instagram, X, TikTok, and YouTube."
                footer={
                  <div className="flex items-center gap-2">
                    <i className="ri-tv-line text-md" />
                    <span>Influencer monitoring</span>
                  </div>
                }
              />
            }
          />
        </div>
      </div>
    </div>
  );
}
